import React from 'react';
// import { Col, Container, Row, Tab, Tabs } from 'react-bootstrap';
import CustomerServicesBannerImage from '../../../images/Inner Page/Customer-Care.webp';

function CustomerServicesBanner() {
   
    return (
        <>
            <section className='banner-sc download-banner'>
                <section className="banner-slider">
                        <div className='home-banner-sc'>
                            <img src={CustomerServicesBannerImage} alt='CustomerServicesBannerImage' className='img-fluid' />
                        </div>
                </section>
            </section>
        </>
    );
}

export default CustomerServicesBanner;